import FollowUpsBoard from "../../components/followups/FollowUpsBoard";

export function FollowUpsPage({
  followUps,
  roleScope,
  onLogCall,
  onMarkComplete,
  onOpenJourney,
}) {
  return (
    <FollowUpsBoard
      followUps={followUps}
      onLogCall={onLogCall}
      onMarkComplete={onMarkComplete}
      onOpenJourney={onOpenJourney}
      roleScope={roleScope}
    />
  );
}

export default FollowUpsPage;
